/* eslint-disable no-nested-ternary */
import { backgroundColorParsing } from 'Utils/UtilityFunctions';
import React, {
  useEffect, RefObject,
} from 'react';
import styled from 'styled-components';
import {
  maxMobile,
  maxTablet,
  maxWidth,
  primaryColor,
  retina, wMedium,
  xmMobile, wMBold,
} from 'Utils/utilsStyle';
import PeopleCardLarge from 'Components/common/components/PeopleCardLarge';
import classNames from 'classnames';
import PersonSkeleton from 'Components/common/skeleton/PersonSkeleton';
import { useSelector } from 'react-redux';
import AlertsSearch from 'Components/alerts/components/AlertsSearch';
import InfiniteScroll from 'react-infinite-scroll-component';
import {
  confirmedPersonCount,
  selectConfirmedPersonLinkedinCount,
  selectLinkedinPeopleLoading,
  selectLinkedinSearchEnded,
  selectMappedId,
  selectPeopleLoading,
  selectSearchEnded,
  selectSearchedPeople,
} from 'Selector/ProfileConfirmationSelector';
import ExtendedSearchLoader from 'Components/common/components/ExtendedSearchLoader';
import NoDataFoundComponent from './NoDataFoundComponent';

const StyleWrapper = styled.div`
  .person-skeleton-loader {
    margin-top: 11px;
  .person-box {
    @media all and (max-width: ${maxMobile}) {
      width: 73px;
      min-width: 73px;
      height: 73px;
    }
  }
  .title-box {
    @media all and (max-width: ${maxMobile}) {
      width: 69%;
      margin-top: 8px;
    }
  }
  .title-box-short {
    @media all and (max-width: ${maxMobile}) {
      margin-bottom: 0px;
    }
  }
    .btn {
      display: none;
    }
  }
  .person-card {
    border: 1.873px solid #fff;
    &.activeCard {
      border-radius: 11.238px;
      border: 1.873px solid ${primaryColor};
      background: #DEF6E6;
      box-shadow: 0px 0px 22.387px -2.634px rgba(0, 0, 0, 0.12);
      padding: 0 8px;
    }
    .person-item {
      margin-top: 4px;
      margin-bottom: 0px;
      .person-item-inner-div {
        padding-left: 6px;
      }
      .person-item-widget {
        .holo-svg {
          @media all and (max-width: ${maxWidth}), ${retina} {
            width: 110px;
            height: 102px;
          }
          @media all and (max-width: ${maxMobile}) {
            width: 82px;
            height: 73px;
          }
        }
        @media all and (max-width: ${maxWidth}), ${retina} {
          width: 115px;
          height: 115px;
          min-width: 115px;
        }
        @media all and (max-width: ${maxMobile}) {
          width: 85px;
          height: 83px;
          min-width: 85px;
        }
        .image-wrap-placeholder {
          .person-image-holder {
            margin: 2px;
            @media all and (max-width: ${maxMobile}) {
              margin: 1.0px 1.09px;
            }
          }
        }
        .name-wrapper {
          bottom: -2px;
          @media all and (max-width: ${maxWidth}), ${retina} {
            height: 20px;
            transform: translate(-52%, -36%);
            }
          @media all and (max-width: ${maxMobile}) {
            height: 15px;
          }
          h4 {
            font-size: 12px !important;
            @media all and (max-width: ${maxMobile}) {
              font-size: 8px !important;
            }
          }
          .anticon {
            @media all and (max-width: ${maxWidth}), ${retina} {
              min-width: 10px;
            }
          }
        }
      }
      .below-card-detail {
        &.compnayNavsOnboarding {
            display:flex;
            flex-direction:column;
            align-items:center;
          }
          .disabled-btn {
            background-color: transparent;
            border:0px;
            cursor: default;
          }       
        .person-name-here {
          font-size: 18px;
          margin-top: -5px;
          margin-bottom: 0px;
          font-weight: ${wMBold};
          @media all and (max-width: ${maxWidth}), ${retina} {
            font-size: 16px;
            margin-top: -1px;
            margin-bottom: 3px;
            line-height: 19px;
          }
          @media all and (max-width: ${maxMobile}) {
            font-size: 12px;
          }
        }
        .person-designation-tip {
          .ant-tooltip {
            .ant-tooltip-content {
              .ant-tooltip-inner {
                @media all and (max-width: ${maxMobile}) {
                  max-width: 150px;
                  }
                  @media all and (max-width: ${xmMobile}) {
                  max-width: 110px;
                }
              }
             }
          }
        }
        .person-company-here {
          font-size: 13px;
          font-weight: ${wMedium};
          color: rgba(102, 121, 130, 1) !important;
          line-height: normal;
          min-height: unset;
          margin-bottom: 10px;
          @media all and (max-width: ${maxTablet}) {
            font-size: 12px;
          }
          @media all and (max-width: ${maxMobile}) {
            font-size: 9px;
            min-height: 24px;
          }
        }
        .follow-c-btn {
          display: none;
        }
      }
    }
  }
  .extended-search-loader-wrapper {
    justify-content: unset;
    @media all and (max-width: ${maxMobile}) {
      width: 160px;
    }
    .main {
      margin: 10px 18px;
      .loader-style {
        @media all and (max-width: ${maxMobile}) {
          height: 40px;
          width: 40px;
        }
      }
      .text {
        @media all and (max-width: ${maxMobile}) {
          font-size: 12px;
          line-height: 14px;
          margin-top: 12px;
        }
      }
    }
  } 
`;

type Props = {
  searchTerm: string,
  activeIndex: number,
  scrollDivPersonRef: RefObject<HTMLDivElement>,
  fetchMore: () => void
  setSearchQuery: (val: string) => void,
  onSearching: (val: string) => void
  setActiveIndex: (val: number) => void,
};

const ConfirmProfileComponent = function ConfirmProfileComponent(props: Props) {
  const {
    setSearchQuery,
    activeIndex, searchTerm, scrollDivPersonRef, onSearching, setActiveIndex, fetchMore,
  } = props;

  const searchEnded = useSelector(selectSearchEnded);
  const linkedinSearchEnded = useSelector(selectLinkedinSearchEnded);
  const linkedinSearchLoading = useSelector(selectLinkedinPeopleLoading);
  const count = useSelector(confirmedPersonCount);
  const extendedSearchCount = useSelector(selectConfirmedPersonLinkedinCount);

  const searchedPeople = useSelector(selectSearchedPeople);
  const peopleLoading = useSelector(selectPeopleLoading);
  const mappedId = useSelector(selectMappedId);

  const userName = localStorage.getItem('fullname') ?? '';
  const company = localStorage.getItem('personCompany') ?? '';

  useEffect(() => {
    if (searchTerm) {
      setSearchQuery(searchTerm);
    }
    if (!searchedPeople.length) {
      setSearchQuery(`${userName}, ${company}`);
      onSearching(`${userName}, ${company}`);
    }
  }, []);

  const handleClick = (index: number) => {
    if (activeIndex === index) {
      setActiveIndex(-1);
    } else {
      setActiveIndex(index);
    }
  };

  useEffect(() => {
    const index = searchedPeople.findIndex((person) => person.personId === mappedId);
    if (index !== -1) {
      setActiveIndex(index);
    }
  }, [searchedPeople]);

  // const searchCount = searchTerm ? (searchedPeople?.length ?? 0) : 0;
  const handleScroll = () => scrollDivPersonRef?.current?.scrollTop || 0;

  useEffect(() => {
    const scrollWrapperElement = scrollDivPersonRef.current;
    scrollWrapperElement?.addEventListener('scroll', handleScroll);
    return () => {
      scrollWrapperElement?.removeEventListener('scroll', handleScroll);
    };
  }, [scrollDivPersonRef]);
  return (
    <StyleWrapper className="onboarding-component-mapping-container">
      <div className="title-search-div">
        <h3 className="title-for-module">Please confirm your identity</h3>
        <AlertsSearch
          onSearching={onSearching}
          placeholderText="Enter your name"
          margin="0px"
          query={searchTerm}
          customClass={classNames({ active: activeIndex > -1 })}
        />
      </div>
      <h6 className="title-heading">
        {`People (${linkedinSearchLoading ? count : count + extendedSearchCount})`}
      </h6>
      {searchedPeople?.length ? (
        <div
          className={classNames(
            'scroll-wrapper-onboarding-company',
            { emptyState: !searchedPeople?.length && !peopleLoading && !linkedinSearchLoading },
          )}
          id="onboardingPersonComponent"
          ref={scrollDivPersonRef}
        >
          <InfiniteScroll
            hasMore={!searchEnded || !linkedinSearchEnded}
            dataLength={searchedPeople?.length}
            next={fetchMore}
            className="infinite-scroll-component-onboarding"
            loader={false}
            scrollableTarget="onboardingPersonComponent"
          >
            <div className="onboarding-component-wrap">
              {searchedPeople?.map((person, i) => (
                <div
                  role="button"
                  tabIndex={0}
                  className={classNames('person-card component-card', { activeCard: i === activeIndex })}
                  onClick={() => handleClick(i)}
                  onKeyPress={() => handleClick(i)}
                  aria-label={`Person card ${i + 1}`}
                >
                  <PeopleCardLarge
                    diameter="140px"
                    diameterXxsm="140px"
                    imageDiameter="140px"
                    tagTextPadding="0px 20px"
                    holoDiameterHeight="123px"
                    holoDiameterWidth="133px"
                    holoDiameterXxsmHeight="123px"
                    holoDiameterXxsmWidth="133px"
                    key={person?.personId}
                    showDrawerIcon={false}
                    persona={person?.archeType?.color}
                    logo={person?.personImage}
                    personName={person?.personName}
                    tag={person?.personDesignation}
                    personaType={person?.archeType?.name}
                    wrapperColor={backgroundColorParsing(person?.personalityTypes)}
                    personalityTypesColors={person?.personalityTypes}
                    hidePersonality={false}
                    follow={false}
                    showCheckBox={false}
                    checked={false}
                    personId={person?.personId}
                    // addRemovePerson={false}
                    company={person?.companyName}
                    disableNavigation
                    profileConfirmation
                  />
                </div>
              ))}
              {peopleLoading ? [1, 2, 3].map(() => (

                <div className="person-card component-card">
                  <PersonSkeleton
                    diameter="140px"
                    diameterSm="100px"
                  />
                </div>
              )) : null}
              {linkedinSearchLoading && !peopleLoading ? (
                <ExtendedSearchLoader />
              ) : null}
            </div>
            {!searchedPeople?.length && !peopleLoading && !linkedinSearchLoading && (
              <NoDataFoundComponent firstText="Can’t find your Profile?" secondText="Enter your name in the search bar." />
            )}
          </InfiniteScroll>
        </div>
      ) : null}
      {!searchedPeople?.length
        ? (
          <div
            className={classNames('onboarding-component-wrap', { emptyWrap: !searchedPeople?.length && !peopleLoading && !linkedinSearchLoading })}
          >
            {linkedinSearchLoading && !peopleLoading ? (
              <ExtendedSearchLoader />
            ) : null}
            {peopleLoading ? [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(() => (
              <div className={classNames('person-card component-card')}>
                <PersonSkeleton
                  diameter="140px"
                  diameterSm="100px"
                />
              </div>
            )) : null}
            {!searchedPeople?.length && !peopleLoading && !linkedinSearchLoading && (
              <NoDataFoundComponent firstText="Can’t find your Profile?" secondText="Enter your name in the search bar." />
            )}
          </div>
        )
        : null}
    </StyleWrapper>
  );
};

export default ConfirmProfileComponent;
